import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import Booking from './components/Booking';

const App = () => {
  const router = createBrowserRouter([
    {
      path: '/',
      element: <div>National Gift Card is the best!</div>,
    },
    {
      path: '/bookings/:readToken',
      element: <Booking />,
    },
  ]);

  return <RouterProvider router={router} />;
};

export default App;
